<template>
  <div id="restaurant-products" class="relative clearfix">
    <div ref="result2"></div>
    <div>
      <div class="tr-about-image vx-col ">
            <swiper v-if="showSlider" :options="swiperOption" dir="ltr" key="ltr" >
              <swiper-slide v-for="(slide, index) in slideImages" :key="index">
                <div class="swipe-image-wrapper bg-white cursor-pointer product-image"
                     v-bind:style="{ 'background-image': 'url(' + slide + ')' }">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div><!--
        <div v-if="restaurant">
          <div class="alert__container" v-if="!restaurant.open">
            <div class="alert alert__warning" role="alert">
              <p class="alert__text"><i class="fas fa-store-slash"></i> Online Ordering Temporarily Unavailable</p>
            </div>
          </div>
        </div>-->
        <div class="tr-landing-title-cont">
          <div class="tr-landing-title-column">
            <img v-if="restaurant" class="logo" :src="restaurant.user_property['Logo']" alt=""/>
            <!--<h3 v-if="restaurant" class="text-primary tr-landing-title" >{{ restaurant.user_property['Restaurant-Name'] }}-->
          </div>
          <div class="tr-landing-title-column">
            <div class="float-right">
              <div class="text-center">
                <img width="30px" src="@/assets/images/turkish-restaurant-icon.png"/>
              </div>
              <div style="font-weight: bold">
                {{restaurant.review}} / 5
              </div>
            </div>
            <google-rating  :item="this.selectedPlace"></google-rating></div>
        </div>

        <vs-divider />

          <div class="restaurant-menu-flex-container">
            <div class="restaurant-menu-flex-item">
          <div v-if="restaurant" class="tr-res-detail-cont" id="restaurant-info" ref="restaurantContainer">
            <div class="tr-res-detail-row">
              <div class="tr-res-detail-col">
                <div class="tr-res-detail-inner-row desktop-only">
                  <h3>Address</h3>
                  <div class="tr-res-detail-text">{{ restaurant.user_property['Address'] }}</div>
                </div>
                <div class="tr-res-detail-inner-row">
                  <h3>Phone</h3>
                  <a class="res-call-button" :href="`tel:${restaurant.phone}`">
                    <div class="tr-res-detail-text">
                      <i class="fa-solid fa-phone"></i> {{ restaurant.phone }}
                    </div>
                  </a>
                </div>
                <div class="tr-res-detail-inner-row" >
                  <h3>Working Hours</h3>
                  <div v-if="restaurant.todayHour" class="tr-res-detail-text">
                    <p v-for="(hour, index) in Object.keys(restaurant.todayHour)" v-bind:key="index" class="font-small text-primary">{{getRestaurantHours(index)}}</p>
                  </div>
                </div>
                <div class="tr-res-detail-inner-row" v-if="restaurant.user_property['Reservation-Key']">
                  <h3>Reservation</h3>
                  <a class="res-call-button"  @click="toggleReservations(true)"><div class="tr-res-detail-text"><i class="fas fa-utensils"></i> Make a Reservation</div></a>

                  <make-reservation :api-key="restaurant.user_property['Reservation-Key']" :restaurant-name="restaurant.user_property['Restaurant-Name']" :is-sidebar-active="resMakePopup" @closeSidebar="toggleReservations" :data-prop="null" />
  <!--                <reservation-details :is-sidebar-active="resDetailPopup" @closeSidebar="toggleReservationDetails" :data-prop="null" />
                  <make-reservation :is-sidebar-active="resCompletePopup" @closeSidebar="toggleReservationComplete" :data-prop="null" />-->
                </div>
                <div class="tr-res-detail-inner-row" v-if="restaurant.user_property['Facebook'] || restaurant.user_property['Twitter'] || restaurant.user_property['Instagram']">
                  <h3>Social Media</h3>
                  <div class="tr-social-icons">
                              <vs-button class="cursor-pointer" type="border" icon-pack="feather" color="#1551b1" icon="icon-facebook" v-if="restaurant.user_property['Facebook']" @click="open_url(restaurant.user_property['Facebook'])" radius></vs-button>
                              <vs-button class="cursor-pointer" type="border" icon-pack="feather" color="#00aaff" icon="icon-twitter" v-if="restaurant.user_property['Twitter']" @click="open_url(restaurant.user_property['Twitter'])" radius></vs-button>
                              <vs-button class="cursor-pointer" type="border" icon-pack="feather" color="#405DE6" icon="icon-instagram" v-if="restaurant.user_property['Instagram']" @click="open_url(restaurant.user_property['Instagram'])" radius></vs-button>
                            </div>
                </div>
              </div>
              <div class="tr-res-detail-col">
                <feather-icon icon="MapIcon" v-if="isMobile || windowWidth <= 992" class="m-0 cursor-pointer map-icon" type="border" @click="toggleMap" />
                <div class="vx-col w-full desktop-full" :class="{showMap}" id="map-container" :style="{height: matchHeight}">
                      <div class="vx-row text-center h-full">
                          <vx-card class="card-map-info h-full">
                           <restaurant-map v-if="restaurant_data" :restaurant_data="restaurant_data" />
                          </vx-card>
                      </div>
                  </div>
              </div>
              </div>
              <div class="tr-res-detail-row mobile-only">
                <div class="tr-res-detail-col"></div>
                <div class="tr-res-detail-col">
                <div class="tr-res-detail-inner-row">
                  <h3>Address</h3>
                <div class="tr-res-detail-text">{{ restaurant.user_property['Address'] }}</div>
                </div>
                </div>
                </div>
          </div>

        <vs-divider />
      </div>
      <div class="restaurant-menu-flex-item" v-if="false">
        <div class="flex product-tabs">
          <h2 class="tr-res-menu-heading" :class="productTab === 0 ? 'active' : ''" @click="productTab = 0">Restaurant Menu</h2>
          <h2 class="tr-res-menu-heading" v-if="hasCatering" :class="productTab === 1 ? 'active' : ''" @click="productTab = 1">Catering Menu</h2>
        </div>
        <div class="product-items" v-if="restaurant_data && restaurant">
          <accordion-products v-if="restaurant_data && productTab === 0" :is-open="restaurant.open" :restaurant_id="restaurant_data.id" :product_id="product_id" />
          <accordion-catering-products v-if="restaurant_data && productTab === 1 || !cateringReady" :catering-response="cateringResponse" :is-open="restaurant.open" :restaurant_id="restaurant_data.id" :product_id="product_id" />
        </div>
        <reviews :result-data="selectedPlace.reviews" v-if="restaurant && selectedPlace" :place_id="restaurant.user_property['Google-Places-ID']"></reviews>
      </div>
      </div>

        <div v-if="restaurant" class="tr-about-text ">
          <h3 v-if="restaurant" >About {{ restaurant.user_property['Restaurant-Name'] }}</h3>
          <p>{{restaurant.user_property['About']}}</p>
        </div>
      <section>
        <div class="container my-5 py-5" style="padding: 0 !important; margin: 0 !important; width: 100% !important;">
          <div class="row d-flex justify-content-center" style="padding-left: 0 !important;">
            <div class="col-md-12 col-lg-12">
              <div class="card text-body">
                <div class="card-body p-4">
                  <a style="float: right;" @click="toggleReviewPopup" ><div class="claim-button mt-2" role="button">Add Review</div></a>
                  <h4 class="mb-0">Reviews</h4>
                  <p class="fw-light mb-4 pb-2">User Comments</p>
                  <div style="margin-bottom: 15px" v-for="(review, index) in reviews" :key="index">
                    <div class="d-flex flex-start">
                      <div>
                        <h6 class="fw-bold mb-1">{{review.user_name}}</h6>
                        <div class="d-flex align-items-center mb-1">
                          <p class="mb-0">
                            {{formatDate(review.updated_at)}}
                          </p>
                        </div>
                        <div class="d-flex align-items-center mb-3" style="font-weight: bold">
                            {{review.average}} / 5
                        </div>
                        <p class="mb-2">
                          {{review.comment}}
                        </p>
                      </div>
                    </div>
                    <hr class="my-0" />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <AddReviewPopup v-if="reviewPopup" :is-sidebar-active="reviewPopup" :restaurantId="restaurant_data.id" @closeSidebar="toggleReviewPopup" :getRestaurantReview="getRestaurantReview"/>
  </div>
</template>


<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import AccordionProducts from '../tabs/AccordionProducts'
import RestaurantMap from './RestaurantMap'
import Reviews from '../../../components/google-places/Reviews'
import GoogleRating from '../../../components/google-places/GoogleRating'
import AccordionCateringProducts from '../tabs/AccordionCateringProducts'
import MakeReservation from '../../../components/reservations/MakeReservation'
import ReservationDetails from '../../../components/reservations/ReservationDetails'
import ReservationComplete from '../../../components/reservations/ReservationComplete'
import AddReviewPopup from '@/views/pages/AddReviewPopup.vue'
import moment from 'moment/moment'
export default {
  props: {
    restaurant_id: {
      type: String,
      required: true
    },
    product_id : {
      type: String
    }
  },
  components: {
    AccordionCateringProducts,
    AccordionProducts,
    MakeReservation,
    ReservationDetails,
    RestaurantMap,
    ReservationComplete,
    ItemGridView: () => import('./components/ItemGridView.vue'),
    ItemListView: () => import('./components/ItemListView.vue'),
    Reviews,
    GoogleRating,
    swiper,
    swiperSlide,
    AddReviewPopup
  },
  metaInfo () {
    return {
      title: this.meta_title,
      titleTemplate: '%s | Turkish Restaurant',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.restaurant ? this.restaurant.user_property['About'].split('.')[0] : ''
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Turkish Mediterranean Cuisine'
        }
      ]
    }
  },
  data () {
    return {
      // Filter Sidebar
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      slideImages: [],
      reviewPopup: false,
      productSidebar: false,
      isFilterSidebarActive: true,
      clickNotClose: true,
      sidebarData: {},
      showMap: false,
      cateringReady: false,
      currentItemView: 'item-grid-view',
      numericItems: [
        { label: 'All' },
        { label: '<= $10', end: 10 },
        { label: '$10 - $100', start: 10, end: 100 },
        { label: '$100 - $500', start: 100, end: 500 },
        { label: '>= $500', start: 500 }
      ],
      algoliaCategories: [
        'hierarchicalCategories.lvl0',
        'hierarchicalCategories.lvl1',
        'hierarchicalCategories.lvl2',
        'hierarchicalCategories.lvl3'
      ],
      data_list: [],
      defaultMapOptions: {
        zoom: 14,
        minZoom: 3,
        center: {
          lat: null,
          lng: null
        },
        title: '',
        description: '',
        streetViewControl: false,
        zoomControl:false,
        mapTypeControl: false
      },
      mapHeight: 0,
      showInfo: false,
      location:null,
      gettingLocation: false,
      errorStr: null,
      restaurant_data: null,
      side: false,
      height: 100,
      selectedPlace: null,
      showSlider: false,
      productTab: 0,
      hasCatering: false,
      resMakePopup: false,
      resDetailPopup: false,
      resCompletePopup: false,
      placeService: null,
      reviews: null
    }
  },
  computed: {
    meta_title () {
      let res = ''
      if (this.restaurant_id.includes('-')) {
        this.restaurant_id.split('-').map(word => {
          let wordie = word.substr(0, 1).toUpperCase()
          wordie += word.substr(1).toLowerCase()
          wordie += ' '
          res += wordie
        })
      }
      return res
    },
    toValue () {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ]
    },
    /*
    placeService () {
      return this.$store.state.api.place_service
    },*/
    cartItems () {
      return this.$store.state.eCommerce.cartItems.slice().reverse()
    },
    productCategories () {
      return this.$store.state.api.productCategories
    },
    restaurant () {
      return this.$store.state.api.restaurant
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist
    },
    // GRID VIEW
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    windowWidth () { return this.$store.state.windowWidth },
    isMobile () { return this.$store.state.api.isMobile }

  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    },
    '$route.params.restaurant_id' (newId) {
      this.restaurant_id = newId
      this.getRestaurant()
    },
    '$route.params.product_id' (newId) {
      this.product_id = newId
      location.reload()
    },
    placeService (val) {
      if (val) {
        this.getRestaurantLocation()
      }
    },
    restaurant: {
      handler () {
        this.$meta().refresh()
      },
      deep: true
    }
  },
  methods: {
    async toggleReviewPopup () {
      if (!this.reviewPopup) {
        const isLoggedIn = await this.$store.state.api.isUserLoggedIn()
        if (isLoggedIn) {
          this.reviewPopup = !this.reviewPopup
        } else {
          this.$router.push({name: 'page-login'})
        }
      } else {
        this.reviewPopup = !this.reviewPopup
      }
    },
    cateringResponse (response) {
      this.cateringReady = true
      this.hasCatering = response
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }
    },
    getRestaurantHours (index) {
      const hour_type = this.restaurant.todayHour[Object.keys(this.restaurant.todayHour)[index]].hourType
      const hour_start = this.restaurant.todayHour[Object.keys(this.restaurant.todayHour)[index]].opening
      const hour_end = this.restaurant.todayHour[Object.keys(this.restaurant.todayHour)[index]].closing

      let am_pm = 'AM'

      let hour_start_hour = parseInt(hour_start.split(':')[0])
      const minute_start_hour = parseInt(hour_start.split(':')[1])
      if (hour_start_hour > 11) {
        am_pm = 'PM'
      }
      let am_pm_end = 'AM'

      let hour_end_hour = parseInt(hour_end.split(':')[0])
      const minute_end_hour = parseInt(hour_end.split(':')[1])
      if (hour_end_hour > 11) {
        am_pm_end = 'PM'
      }

      if (hour_start_hour !== 12) {
        hour_start_hour = hour_start_hour % 12
      }
      if (hour_end_hour !== 12) {
        hour_end_hour = hour_end_hour % 12
      }

      return `${hour_type} - ${this.handleDigit(hour_start_hour)}:${this.handleDigit(minute_start_hour)} ${am_pm} to ${this.handleDigit(hour_end_hour)}:${this.handleDigit(minute_end_hour)} ${am_pm_end}`
    },
    handleDigit (input) {
      return (input < 10) ? `0${input}` : input
    },
    setImageHeight () {
      this.image_width = this.$refs.restaurantCard.$el.clientWidth
      this.image_height = Math.floor((this.image_width * 40) / 57)
    },
    mapClick () {
      const urlSuffix = this.restaurant.user_property.Address
      window.open(
        'https://www.google.com/maps/search/?api=1&query='.concat(urlSuffix),
        '_blank'
      )
    },
    open_url (url) {
      if (!url.startsWith('https://')) {
        url = 'https://'.concat(url)
      }
      window.open(url, '_blank')
    },
    toggleMap () {
      this.showMap = !this.showMap
    },
    matchHeight () {
      return this.$refs.restaurantContainer.clientHeight.concat('px')
    },
    toggleInfoWindow () {
      this.showInfo = true
    },
    infoClicked () {
    },
    toggleProductSidebar (val = false) {
      this.productSidebar = val
    },
    toggleReservations (val = false) {
      this.resMakePopup = val
    },
    toggleReservationDetails (val = false) {
      this.resDetailPopup = val
      if (!this.resDetailPopup) {
        this.toggleReservationComplete(true)
      }
    },
    toggleReservationComplete (val = false) {
      this.resCompletePopup = val
    },
    toggleFilterSidebar () {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart (item) {
      //this.$store.dispatch('eCommerce/additemInCart', item)
      if (item.size) {
        const selected_size = item.size.items[0]
        let name = selected_size.name
        if (selected_size.price !== '0') {
          name = name.concat(' - $').concat(selected_size.price)
        }
        item.size.selected_value = {label: name, value: selected_size.id, price: selected_size.price}
      }

      this.sidebarData = item
      this.toggleProductSidebar(this.sidebarData)
    },
    cartButtonClicked () {
    },
    mergeProducts (categories) {
      const list = []
      categories.map(function (value) {
        value.products.map(function (value) { list.push(value) })
      })
      this.data_list = list
    },
    getRestaurantReview () {

      this.$vs.loading()

      const payload = {
        restaurantId: null,
        restaurantAlias: this.restaurant_id
      }

      this.$store.dispatch('api/getRestaurant', payload)
        .then(() => {
          if (this.restaurant) {
            this.restaurant_data = this.restaurant

            //this.getProductList()
            setTimeout(() => {
              this.$vs.loading.close()

              if (this.restaurant.user_property['Logo']) {
                this.$store.commit('api/SET_SHOW_RESTAURANT_LOGO', true)
              }
            }, 500)
            //this.getRestaurantLocation()
            this.defaultMapOptions.title = this.restaurant_data.name
            this.defaultMapOptions.description = this.restaurant_data.description

            const rest_location = JSON.parse(this.restaurant_data.user_property.Location)
            this.setMapLocation(rest_location)
            this.getReviews()
          } else {
            this.$vs.loading.close()
            this.$router.push({name: 'page-error-404'})
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getPlaceDetails (place_id, callback) {
      const self = this
      try {
        this.placeService.getDetails({placeId: place_id}, function (PlaceResult) {
          // PlaceResult is an object
          // PlacesServiceStatus is a string
          self.selectedPlace = PlaceResult
          callback(PlaceResult)
        })
      } catch (e) {
        console.error('place error', e)
      }

    },
    setMapLocation (location) {
      this.defaultMapOptions.center = location
    },
    async getLocation () {

      return new Promise((resolve, reject) => {
        if (!('geolocation' in navigator)) {
          reject(new Error('Geolocation is not available.'))
        }

        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos)
        }, err => {
          reject(err)
        })

      })
    },
    async locateMe () {

      this.gettingLocation = true
      try {
        this.gettingLocation = false
        this.location = await this.getLocation()
        this.defaultMapOptions.center.lat = this.location.coords.latitude
        this.defaultMapOptions.center.lng = this.location.coords.longitude
      } catch (e) {
        this.gettingLocation = false
        this.errorStr = e.message
      }

    },
    async getRestaurantLocation () {
      //todo replace geocoder with vue meta geocode lib
      if (this.restaurant) {
        this.getPlaceDetails(this.restaurant.user_property['Google-Places-ID'],
          (details) => {
            details.photos.map((photo) => {
              this.slideImages.push(photo.getUrl())
              setTimeout(() => { this.showSlider = true }, 1000)
            })
            // this.setMapLocation(details.geometry.location)
          })
      }
    },
    initPlaces () {
      this.placeService = new window.google.maps.places.PlacesService(this.$refs.result2)
    },
    formatDate (date) {
      return moment(date).format('ddd, MMM D YYYY')
    },
    async getReviews () {
      const payload = {
        restaurantId: this.restaurant_data.id
      }
      this.$store.dispatch('api/getReviews', payload)
        .then((response) => {
          this.reviews = response.data
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  beforeCreate () {
    this.$store.commit('api/SET_RESTAURANT', null)
    this.$store.commit('api/SET_SHOW_RESTAURANT_LOGO', false)
    this.$store.commit('api/SET_SHOW_WEBSITE', false)
  },
  beforeDestroy () {
    this.$store.commit('api/SET_SHOW_RESTAURANT_LOGO', false)
    this.$store.commit('api/SET_SHOW_WEBSITE', false)
  },
  mounted () {
    this.getRestaurantReview()
    setTimeout(() => {
      this.initPlaces()
    }, 500)
  }
}
</script>

<style lang="scss">
.alert__text {
  margin:0;
}
.desktop-full{
  height:100%;
}
.swiper-container {
  overflow: hidden;
  position: relative;
}
.swiper-container img {
  max-width: 100%;
}
.tr-about-section {
  border-bottom:1px solid #ccc;
}
.tr-about-section.vx-row {
  margin-bottom:20px;
}
.tr-res-menu-heading{
  font-size:18px;
  width:max-content;
  padding:10px 20px;
  border-top-left-radius:7px;
  border-top-right-radius:7px;
  border:1px solid #ebebeb;
  border-bottom:none;
  margin-right:5px;
  cursor:pointer;
&:last-child{
  margin-right:0px;
}
  &.active {
    background-color:#ff6b1e;
    color:#fff;
  }
}
.tr-about-restaurant.vx-row {
  margin:20px 0;
  min-height:200px;
  width:100%;
  max-width: 100%;
}
.tr-about-text h2 {
  margin-bottom:20px;
}
.tr-about-text p {
  margin-bottom:20px;
  font-size:14px;
  color:#000;
}
.tr-about-image{
  position:relative;
  margin-bottom:20px;
}
.tr-about-image-logo {
  img{
    width:150px;
    display: block;
  }
  position:absolute;
  bottom:0px;
  left:0px;
  z-index: 1;
}
.tr-about-image .swipe-image-wrapper {
  height:400px;
}
.tr-landing-title-cont{
  display:flex;
  justify-content: space-between;
  align-items: center;
}
.tr-landing-title-column{
  width:max-content;
  .logo {
    max-width: 300px;
  }
}
.tr-landing-title {
  text-align:left;
  font-size:42px;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom:20px;
}
.tr-res-detail-row{
  display:flex;
  justify-content: space-between;
}
.tr-res-detail-col{
  width:calc(50% - 20px);
  min-height:max-content;
}
.tr-res-detail-inner-row {
  margin-bottom:20px;
}
.tr-res-detail-text {
  color:#000;
  font-size:16px;
  font-weight: 400;
  margin-top:15px;
}
.tr-social-icons{
  button{
    margin:0 5px;
  }
  display: flex;
    justify-content: flex-start;
    margin-top: 15px;
}
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {

    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}
.item-img-container {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.swipe-image-wrapper {
  width: 100%;
  height: 250px;
  background-size:cover;
  background-position: center;
  border-radius: 5px;

}
#map-container {
  padding-right: 0;
  height:100%;
}
.mobile-only {
  display:none;
}
.product-tabs{
  border-bottom:1px solid #ebebeb;
  text-align: center;
}
.restaurant-menu-flex-container{
  display:flex;
  flex-direction: column;
}
@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: .5rem;
    }

    .vs-sidebar--items {
      border-radius: .5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}
.mobile {
  #map-container {
    padding: 0;
    margin-top: 20px;
    height: 250px;
    display: none;
  }
  #map-container.showMap {
    display: block;
  }
  .restaurant-info-wrapper {
    display: flex;
    flex-direction: column;
  }

  .map-icon {
    padding: 9px;
    border-radius: 50%;
    border: solid 1px black;
  }
}
@media screen and (max-width:860px){
  .trproductitem {
    width: 100%;
  }
}
.swiper-pagination {
  left: 50%;
  transform: translate(-50%, -20px);

  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    margin-right: 2px;
  }
  .swiper-pagination-bullet-active {
    background: white !important;
  }
}
@media (max-width:768px){
  .restaurant-menu-flex-container{
  flex-direction: column-reverse;
}
  .tr-landing-title {
    text-align:center;
  }
  .tr-about-image-logo {
  img{
    width:100px;
    display: block;
  }
  position:absolute;
  bottom:10px;
  left:10px;
  z-index: 1;
}
  .tr-landing-title-cont{
    flex-wrap: wrap;
    justify-content: center;
  }
.tr-about-image .swipe-image-wrapper {
  height:200px;
}
.tr-landing-title {
  font-size:32px;
}
.tr-about-text p {
  font-size:12px;
  text-align: justify;
}
.tr-res-detail-row{
  flex-direction:column;
}
.tr-res-detail-col{
  width:100%;
  text-align: center;
}
.tr-social-icons{
    justify-content: center;
}
.desktop-full {
  height:auto;
}
.tr-res-menu-heading{
  font-size:14px;
}
.desktop-only {
    display:none;
  }
  .mobile-only{
    display:block;
    margin-top:15px;
  }
  .product-tabs {
    justify-content: flex-start;
  }
  .tr-landing-title-column{
  .logo {
    max-width: 250px;
    margin-bottom:20px;
  }
}
}
@media (max-width:340px){
  .product-tabs {
    justify-content: space-between;
  }
}
</style>
